import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { SourceSystem } from '../../../models/customer.model';
import { SourceSystemService } from 'app/services/source-system/source-system.service';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'kv-sourceSystem-form',
  templateUrl: 'sourceSystemForm.html',
  styles: ['label.required:after {top: 0}']
})

export class SourceSystemFormComponent implements OnInit {
  @Output() sourceSystemAdded: EventEmitter<any> = new EventEmitter<any>();
  @Output() sourceSystemUpdated: EventEmitter<any> = new EventEmitter<any>();
  @Input() dialogBoxSourceSystem: SourceSystem;
  addEditForm: FormGroup;
  fields: any;
  public invalidSubmit: boolean;

  constructor(
    private formBuilder: FormBuilder,
    public sourceSystemService: SourceSystemService
  ) { }

  ngOnInit(): void {
    this.addEditForm = this.formBuilder.group({
      'name': new FormControl(this.dialogBoxSourceSystem.name),
      'description': new FormControl(this.dialogBoxSourceSystem.description),
      'host_id': new FormControl(this.dialogBoxSourceSystem.host_id)
    });

    this.sourceSystemService.getFields().subscribe(res => {
      this.fields = res;
    });

  }

  saveOrUpdate(dialogBox: any): void {
    console.log('request to insert or update source system');
    console.log(this.dialogBoxSourceSystem);

    if (!this.addEditForm.value.name && !this.addEditForm.value.description && !this.addEditForm.value.host_id ) {
      this.invalidSubmit = true;
      return;
    }

    if (!this.addEditForm.valid ) {
      this.invalidSubmit = true;
      return;
    } else {
      this.invalidSubmit = false;
    }

    let newData = Object.assign({}, this.dialogBoxSourceSystem, this.addEditForm.value);
    if (newData.id == null) {
      this.sourceSystemAdded.emit(newData);
    } else {
      this.sourceSystemUpdated.emit(newData);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/views/customerDB/source-system/sourceSystemForm.component.ts